<template>
  <div class="deposit-disclaimer" v-if="disclaimer">
    <div class="deposit-disclaimer__line"></div>
    <p class="deposit-disclaimer__text">
      <span v-html="disclaimer"></span>
    </p>
  </div>
</template>

<script src="./deposit-disclaimer.js"></script>
<style src="./deposit-disclaimer.scss" lang="scss"></style>
